import React from 'react';
import { createMuiTheme, makeStyles, MuiThemeProvider, Paper, Switch, TableCell, Tabs, Tab, Typography, withStyles, TextareaAutosize } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import { Divider, TextField, Snackbar } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import Loader from 'react-loader-spinner'
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from "mui-datatables";
import { useLocation } from 'react-router-dom';
import MuiAlert from '@material-ui/lab/Alert';
import api from '../api'
import { useHistory } from 'react-router-dom';
import ic_error from '../../assets/ic_error.png';
import { number } from 'echarts';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function TambahJadwal(props) {
    const location = useLocation();
    const history = useHistory()
    // console.log(location.state);
    const doctor_detail_id = location.state.data.doctor_detail_id
    // console.log(doctor_detail_id);
    const classes = useStyles()
    const [waktu, set_waktu] = React.useState(null)
    let effective_date;
    const [hari, setHari] = React.useState([])
    // const [data, setData] = React.useState([])
    const [time_start, set_time_start] = React.useState(null)
    const [time_end, set_time_end] = React.useState(null)
    const [time_type, set_time_type] = React.useState(null)
    const [time, set_time] = React.useState(null)
    const [service_duration, set_service_duration] = React.useState("-")
    const [remark, setRemark] = React.useState("")
    const [internalNotes, setInternalNotes] = React.useState("")
    const [quota, set_quota] = React.useState(null)
    const [quota_bpjs, set_quota_bpjs] = React.useState(null)
    const [service_type, set_service_type] = React.useState(null)
    const [room, set_room] = React.useState(null)
    const [list_room, set_list_room] = React.useState([])
    const [data, set_data] = React.useState([])
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [loading, setLoading] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null)
    const [visibleError, setVisibleError] = React.useState(false);
    const [openAlert, setOpenAlert] = React.useState(false);
    // const [flagging, setFlagging] = React.useState(false)
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [selectedDateEnd, setSelectedDateEnd] = React.useState(null);
    const [notesDokter, setNotesDokter] = React.useState(null)
    const [visibleNotes, setVisibleNotes] = React.useState(false)
    // console.log(selectedDate);

    const [errorHari, setErrorHari] = React.useState(false);
    const [errorWaktu, setErrorWaktu] = React.useState(false);
    const [errorJamMulai, setErrorJamMulai] = React.useState(false);
    const [errorJamSelesai, setErrorJamSelesai] = React.useState(false);
    const [errorTipeAntrian, setErrorTipeAntrian] = React.useState(false);
    const [errorSlotWaktu, setErrorSlotWaktu] = React.useState(false);
    const [errorLayanan, setErrorLayanan] = React.useState(false);
    const [errorRoom, setErrorRoom] = React.useState(false);
    const [errorDurasi, setErrorDurasi] = React.useState(false);

    const [textErrorHari, setTextErrorHari] = React.useState("");
    const [errorWaktuMessage, setErrorWaktuMessage] = React.useState(null);
    const [errorJamMulaiMessage, setErrorJamMulaiMessage] = React.useState(null);
    const [errorJamSelesaiMessage, setErrorJamSelesaiMessage] = React.useState(null);
    const [errorTipeAntrianMessage, setErrorTipeAntrianMessage] = React.useState(null);
    const [errorSlotWaktuMessage, setErrorSlotWaktuMessage] = React.useState(null);
    const [errorLayananMessage, setErrorLayananMessage] = React.useState(null);
    const [errorRoomMessage, setErrorRoomMessage] = React.useState(null);
    const [errorDurasiMessage, setErrorDurasiMessage] = React.useState(null);

    const handleDateChange = (date) => {
        if (date && !isNaN(new Date(date).getTime())) {
            setErrorJamMulai(false)
            setErrorJamMulaiMessage(null)
            let jam = date.getHours()
            let menit = date.getMinutes()
            setSelectedDate(date)
            if (jam < 10) {
                jam = `0${jam}`
            }
            console.log(jam, menit);
            if (menit < 10) {
                menit = `0${menit}`
            }
            if (menit === 0) {
                set_data({
                    ...data,
                    "time_start": `${jam}:${menit}0`
                });
                set_time_start(`${jam}:${menit}0`)
            } else {
                set_data({
                    ...data,
                    "time_start": `${jam}:${menit}`
                });
                set_time_start(`${jam}:${menit}`)
            }
        }
    };

    const handleDateEndChange = (date) => {
        if (date && !isNaN(new Date(date).getTime())) {
            setErrorJamSelesai(false)
            setErrorJamSelesaiMessage(null)
            let jam = date.getHours()
            let menit = date.getMinutes()
            console.log(jam, menit);
            setSelectedDateEnd(date)
            if (menit === 0) {
                set_data({
                    ...data,
                    "time_end": `${jam}:${menit}0`
                });
                set_time_end(`${jam}:${menit}0`)
            } else {
                set_data({
                    ...data,
                    "time_end": `${jam}:${menit}`
                });
                set_time_end(`${jam}:${menit}`)
            }
        }
    };
    // console.log(time_start);
    let schedule = []
    if (waktu) {
        let date = waktu.getDate()
        let month = waktu.getMonth() + 1
        let year = waktu.getFullYear()
        // console.log(date, month, year);
        effective_date = `${year}-${month}-${date}`
    }
    // console.log(hari)
    React.useEffect(() => {
        setNotesDokter(location.state.value.notes)
        getRuangan()
    }, [])

    const getRuangan = () => {
        api.create().getRoomFilter("activeinactive=1").then(response => {
            console.log(response.data);
            let listRoom = []
            response.data.data.map((el, idx) => {
                listRoom.push({
                    id: el.id,
                    name: `Gd. ${el.building_name}, Lantai.${el.floor}, Ruangan ${el.name}`
                })
            })
            set_list_room(listRoom)
        })
    }
    // console.log(list_room);

    const handleSubmit = () => {
        if (waktu === null) {
            console.log("1");
            setErrorWaktu(true)
            setErrorWaktuMessage("Tanggal Harus diisi")
        } else if (selectedDate === null) {
            console.log("2");
            setErrorJamMulai(true)
            setErrorJamMulaiMessage("Jam Mulai Harus diisi")
        } else if (selectedDateEnd === null) {
            console.log("3");
            setErrorJamSelesai(true)
            setErrorJamSelesaiMessage("Jam Selesai Harus diisi")
        } else if (time_type === null) {
            console.log("4");
            setErrorTipeAntrian(true)
            setErrorTipeAntrianMessage("Tipe Antrian Harus diisi")
        } else if (!time && time_type.name !== "FIFO" && time_type.name !== "FIFO CHECKIN") {
            console.log("5");
            console.log('masuk');
            setErrorSlotWaktu(true)
            setErrorSlotWaktuMessage("slot waktu Harus diisi")
            // } else if (service_duration === "") {
            //     setErrorDurasi(true)
            //     setErrorDurasiMessage("durasi layanan Harus diisi")
        } else if (service_type === null) {
            console.log("6");
            setErrorLayanan(true)
            setErrorLayananMessage("Layanan Pasien Harus diisi")
        } else if (room === null) {
            console.log("7");
            setErrorRoom(true)
            setErrorRoomMessage("Lokasi praktek Harus diisi")
        } else if (hari.length === 0) {
            console.log("8");
            setErrorHari(true)
            setTextErrorHari("Hari Harus diisi")
        } else {
            if (hari.length >= 1) {
                hari.map(el => {
                    schedule.push({
                        "day_id": el.id,
                        "session": [
                            {
                                "service_type": service_type === null ? null : service_type.id,
                                "time_type": time_type === null ? null : time_type.id,
                                "time": time === null ? 0 : time,
                                "service_duration": service_duration === "" || service_duration === "-" || service_duration === null ? 0 : service_duration,
                                "quota": quota === null ? 0 : quota,
                                "quota_bpjs": quota_bpjs === null ? 0 : quota_bpjs,
                                "time_start": time_start,
                                "time_end": time_end,
                                "room_id": room === null ? null : room.id,
                                "remarks": remark === "" ? null : remark,
                                "internal_notes": internalNotes === "" ? null : internalNotes
                            }
                        ]
                    })
                })
            } else {
                schedule = [
                    {
                        "day_id": hari.id,
                        "session": [
                            {
                                "service_type": service_type === null ? null : service_type.id,
                                "time_type": time_type === null ? null : time_type.id,
                                "time": time === null ? 0 : time,
                                "service_duration": service_duration === "" || service_duration === "-" || service_duration === null ? 0 : service_duration,
                                "quota": quota === null ? 0 : quota,
                                "quota_bpjs": quota_bpjs === null ? 0 : quota_bpjs,
                                "time_start": time_start,
                                "time_end": time_end,
                                "room_id": room === null ? null : room.id,
                                "remarks": remark === "" ? null : remark,
                                "internal_notes": internalNotes === "" ? null : internalNotes
                            }
                        ]
                    }
                ]

            }
            let payload = {
                "doctor_detail_id": doctor_detail_id,
                "effective_date": effective_date,
                "schedule": schedule
            }
            console.log('test', JSON.stringify(payload));
            api.create().createDokterSchedule(payload).then(response => {
                console.log(response);
                if (response.data) {
                    setLoading(false)
                    if (response.data.status === true) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("Succes")
                        setTimeout(() => {
                            history.goBack()
                        }, 1000)
                        // history.push({
                        //     pathname: '/masterdata/Jadwal-dokter'
                        // })
                        // props.onClose()
                        // props.getData()
                    } else {
                        // alert(response.data.message)
                        setErrorMessage(response.data.data)
                        setVisibleError(true)
                    }
                }
            })
        }
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const listHari = [
        {
            id: 7,
            name: "Minggu"
        },
        {
            id: 1,
            name: "Senin"
        },
        {
            id: 2,
            name: "Selasa"
        },
        {
            id: 3,
            name: "Rabu"
        },
        {
            id: 4,
            name: "Kamis"
        },
        {
            id: 5,
            name: "Jum'at"
        },
        {
            id: 6,
            name: "Sabtu"
        },
    ]

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const listJam = [
        {
            id: 0,
            name: "07:00"
        },
        {
            id: 1,
            name: "08:00"
        },
        {
            id: 2,
            name: "09:00"
        },
        {
            id: 3,
            name: "11:00"
        },
        {
            id: 4,
            name: "11:00"
        },
    ]

    const listAntrian = [
        {
            id: 1,
            name: "BPJS"
        },
        {
            id: 2,
            name: "Umum"
        },
        {
            id: 3,
            name: "BPJS/Umum"
        },
    ]

    const listTipeAntrian = [
        {
            id: 1,
            name: "TIMESLOT"
        },
        {
            id: 2,
            name: "TIMEBLOK"
        },
        {
            id: 3,
            name: "FIFO"
        },
        {
            id: 4,
            name: "FIFO CHECKIN"
        }
    ]

    console.log(data, '---------');

    const columns = [
        {
            name: "hari",
            label: "Hari"
        },
        {
            name: "time_start",
            label: "Jam Mulai"
        },
        {
            name: "time_end",
            label: "Jam Selesai"
        },
        {
            name: "time_type",
            label: "Tipe Antrian"
        },
        {
            name: "time",
            label: "Slot Jam"
        },
        {
            name: "quota",
            label: "Kuota Pasien"
        },
        {
            name: "quota_bpjs",
            label: "Kuota BPJS"
        },
        {
            name: "service_type",
            label: "Layanan"
        },
        {
            name: "room",
            label: "Lokasi Praktek"
        },
        {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button
                                // onClick={() => handleSeeDetail(tableMeta)}
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                    marginRight: 20
                                }}>
                                <img src="https://img.icons8.com/metro/26/26e07f/show-property.png" />
                            </button>
                        </div>
                    )
                }
            }
        }
    ];

    const listSlotWaktu = [
        { id: 1, name: "10" },
        { id: 2, name: "11" },
        { id: 3, name: "12" },
        { id: 4, name: "13" },
        { id: 5, name: "14" },
        { id: 6, name: "15" },
    ]

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleBatal = () => {
        history.goBack()
    }

    let dataTable = []
    const [flagging, setFlagging] = React.useState(false)
    if (data.hari && data.time_start && data.time && data.time_end && data.service_type && data.time_type && data.quota && data.quota_bpjs && data.room) {
        if (data.hari.length >= 1) {
            data.hari.map(el => {
                let obj = {
                    "hari": el,
                    "service_type": service_type.name,
                    "time_type": time_type.name,
                    "quota": quota,
                    "quota_bpjs": quota_bpjs,
                    "time_start": time_start,
                    "time_end": time_end,
                    "room": room.name,
                    "time": time
                }
                dataTable.push(obj)
            })
        }
    }


    const handleEdit = () => {
        setFlagging(false)
    }
    console.log(data);

    return (
        <div>
            <div>
                <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={statusAlert}>
                        {messageAlert}
                    </Alert>
                </Snackbar>
                {loading ? loadingComponent : null}

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 30px' }}>
                    <div className="column-1" style={{ width: '80%' }}>
                        <Typography style={{ fontFamily: 'poppins', letterSpacing: 1.5, color: '#2A9C6C' }}>{location.state.name} </Typography>
                        <Typography style={{ fontFamily: 'poppins', letterSpacing: 1.5, color: '#a4a4a4', fontSize: 15 }}>Klinik {location.state.data.name} </Typography>

                    </div>
                    <div className="column-2" style={{}}>
                        <TextField
                            style={{ width: '100%' }}
                            disabled={true}
                            multiline
                            maxRows={2}
                            rows={2}
                            InputProps={{
                                disableUnderline: true,
                                style: {
                                    color: 'black'
                                }
                            }}
                            inputProps={{
                                style: {
                                    letterSpacing: 1.5, color: '#a4a4a4', fontSize: 14
                                }
                            }}
                            value={notesDokter}
                        />
                        {notesDokter && notesDokter.length > 20 && (
                            <div style={{ width: '80%', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}
                                onClick={() => {
                                    setVisibleNotes(true)
                                }}
                            >
                                <Typography style={{ color: '#37a7ed', fontSize: 12 }}>Lihat Detail</Typography>
                            </div>
                        )}
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, margin: 'auto', width: '100%' }}>
                    <div className="column-1" style={{ marginRight: 50 }}>
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="tanggalBerlaku"
                                    label="Tanggal Berlaku"
                                    format="dd/MM/yyyy"
                                    minDate={new Date()}
                                    required={true}
                                    error={errorWaktu}
                                    helperText={errorWaktuMessage}
                                    value={waktu}
                                    onChange={(date) => {
                                        setErrorWaktu(false)
                                        setErrorWaktuMessage(null)
                                        set_waktu(date)
                                        forceUpdate()
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '80%' }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>

                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardTimePicker
                                    style={{ width: '80%', marginTop: 30, marginTop: 30 }}
                                    margin="normal"
                                    id="jamMulai"
                                    error={errorJamMulai}
                                    required={true}
                                    helperText={errorJamMulaiMessage}
                                    clearLabel
                                    ampm={false}
                                    label="Jam Mulai"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>

                        <div className="">
                            <Autocomplete
                                // multiple
                                options={listTipeAntrian}
                                style={{ width: '80%', marginTop: 30 }}
                                getOptionLabel={(option) => option.name}
                                debug
                                required={true}
                                name='Tipe Antrian'
                                value={time_type}
                                id="tipeAntrian"
                                onChange={(event, newInputValue) => {
                                    if (newInputValue !== null) {
                                    set_time_type(newInputValue)
                                    setErrorTipeAntrian(false)
                                    setErrorTipeAntrianMessage(null)
                                    if (newInputValue.name === "TIMESLOT") {
                                        setErrorDurasi(false)
                                        setErrorDurasiMessage(null)
                                        set_service_duration(time === null ? "-" : time)
                                    }
                                    if (newInputValue.name === "FIFO" || newInputValue.name === "FIFO CHECKIN") {
                                        setErrorSlotWaktu(false)
                                        setErrorSlotWaktuMessage(null)
                                    }
                                    set_data({
                                        ...data,
                                        "time_type": newInputValue.name
                                    })
                                }

                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Tipe Antrian"
                                        error={errorTipeAntrian}
                                        helperText={errorTipeAntrianMessage}
                                        required={true}
                                    />
                                }
                            />
                        </div>

                        <div>
                            <TextField
                                style={{ marginTop: 30, width: '80%' }}
                                id="durasiLayanan"
                                name="Durasi Layanan"
                                label="Durasi Layanan"
                                // required={true}
                                disabled={time_type && time_type.name !== "TIMESLOT" ? false : true}
                                value={service_duration}
                                type='number'
                                // error={errorDurasi}
                                // helperText={errorDurasiMessage}
                                // placeholder={"10"}
                                onChange={(e) => {
                                    set_service_duration(e.target.value)
                                    // setErrorDurasi(false)
                                    // setErrorDurasiMessage(null)
                                    forceUpdate()
                                    // set_data({
                                    //     ...data,
                                    //     "quota_bpjs": e.target.value
                                    // })
                                }}
                                inputProps={{
                                    style: {

                                    }
                                }}
                                InputLabelProps={{
                                    style: {

                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>

                        <div>
                            <TextField
                                style={{ width: '80%', marginTop: 30 }}
                                id="kuotaPasien"
                                name="Kuota Pasien"
                                label="Kuota Pasien"
                                value={quota}
                                required={true}
                                type="number"
                                placeholder={"10"}
                                onChange={(e) => {
                                    set_quota(e.target.value)
                                    set_data({
                                        ...data,
                                        "quota": e.target.value
                                    })
                                }}
                                inputProps={{
                                    style: {

                                    }
                                }}
                                InputLabelProps={{
                                    style: {

                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div>
                            <TextField
                                style={{ width: '80%', marginTop: 30 }}
                                id="kuotaPasienBpjs"
                                name="Kuota Pasien BPJS"
                                label="Kuota Pasien BPJS"
                                value={quota_bpjs}
                                type="number"
                                placeholder={"10"}
                                onChange={(e) => {
                                    set_quota_bpjs(e.target.value)
                                    set_data({
                                        ...data,
                                        "quota_bpjs": e.target.value
                                    })
                                }}
                                inputProps={{
                                    style: {

                                    }
                                }}
                                InputLabelProps={{
                                    style: {

                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div>
                            <TextField
                                style={{ width: '80%', marginTop: 30 }}
                                label="Catatan Publik"
                                value={remark}
                                placeholder={"Input Catatan Publik"}
                                onChange={(e) => {
                                    setRemark(e.target.value)
                                }}
                                inputProps={{
                                    style: {

                                    }
                                }}
                                InputLabelProps={{
                                    style: {

                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                    {
                        !data.hari ?
                            <div className="column-2">
                                <div className="">
                                    <Autocomplete
                                        multiple
                                        style={{ marginTop: 19, width: '80%' }}
                                        options={listHari}
                                        required={true}
                                        debug
                                        getOptionLabel={(option) => option.name}
                                        name='hari'
                                        id="hari"
                                        value={hari}
                                        onChange={(event, newInputValue) => {
                                            console.log(newInputValue);
                                            if (newInputValue.length > 0) {
                                                let temp = []
                                                newInputValue.map((el, idx) => {
                                                    temp.push(el.name)
                                                    set_data({
                                                        ...data,
                                                        "hari": temp
                                                    })
                                                })
                                            } else {
                                                set_data({
                                                    ...data,
                                                    "hari": []
                                                })
                                            }
                                            setHari(newInputValue)
                                            setErrorHari(false)
                                            setTextErrorHari("")
                                            // set_data({
                                            //     ...data,
                                            //     "hari": newInputValue.name
                                            // })
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Hari"
                                                error={errorHari}
                                                helperText={textErrorHari}
                                                required={true}
                                            />
                                        }
                                    />
                                </div>
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin="normal"
                                            style={{ marginTop: 37, width: '80%' }}
                                            id="jamSelesai"
                                            clearLabel
                                            ampm={false}
                                            required={true}
                                            label="Jam Selesai"
                                            error={errorJamSelesai}
                                            helperText={errorJamSelesaiMessage}
                                            value={selectedDateEnd}
                                            onChange={handleDateEndChange}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div>
                                    <TextField
                                        style={{ marginTop: 25, width: '80%' }}
                                        id="slotWaktu"
                                        name="Slot Waktu"
                                        label="Slot Waktu"
                                        required={time_type !== null && time_type.name !== "FIFO" && time_type.name !== "FIFO CHECKIN" ? true : false}
                                        value={time}
                                        error={errorSlotWaktu}
                                        helperText={errorSlotWaktuMessage}
                                        placeholder={"10"}
                                        onChange={(e) => {
                                            console.log(time_type);
                                            if (time_type && time_type.name === 'TIMESLOT') {
                                                set_service_duration(e.target.value)
                                            }
                                            set_time(+e.target.value)
                                            setErrorSlotWaktu(false)
                                            setErrorSlotWaktuMessage(null)
                                            set_data({
                                                ...data,
                                                "time": +e.target.value
                                            })
                                        }}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <Autocomplete
                                        // multiple
                                        options={listAntrian}
                                        style={{ marginTop: 37, width: '80%' }}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        name='Layanan Pasien'
                                        id="layananPasien"
                                        value={service_type}
                                        onChange={(event, newInputValue) => {
                                            set_service_type(newInputValue)
                                            setErrorLayanan(false)
                                            setErrorLayananMessage(null)
                                            set_data({
                                                ...data,
                                                "service_type": newInputValue.name
                                            })
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Opsi Pembayaran"
                                                required={true}
                                                error={errorLayanan}
                                                helperText={errorLayananMessage}
                                            />
                                        }
                                    />
                                </div>
                                <div className="">
                                    <Autocomplete
                                        // multiple
                                        style={{ marginTop: 35, width: '80%' }}
                                        options={list_room}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        required={true}
                                        name='Lokasi Praktek'
                                        id="lokasiPraktek"
                                        value={room}
                                        onChange={(event, newInputValue) => {
                                            set_room(newInputValue)
                                            setErrorRoom(false)
                                            setErrorRoomMessage(null)
                                            set_data({
                                                ...data,
                                                "room": newInputValue.name
                                            })
                                            setFlagging(true)
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Lokasi Praktek"
                                                error={errorRoom}
                                                helperText={errorRoomMessage}
                                                required={true}
                                            />
                                        }
                                    />
                                </div>
                                <TextField
                                    style={{ width: '80%', marginTop: 30 }}
                                    label="Catatan Internal"
                                    value={internalNotes}
                                    placeholder={"Input Catatan Internal"}
                                    onChange={(e) => {
                                        setInternalNotes(e.target.value)
                                    }}
                                    inputProps={{
                                        style: {

                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            :
                            <div className="column-2">
                                <div className="">
                                    <Autocomplete
                                        multiple
                                        style={{ marginTop: hari != false ? 8 : 19, width: '80%' }}
                                        options={listHari}
                                        required={true}
                                        debug
                                        getOptionLabel={(option) => option.name}
                                        name='hari'
                                        id="hari"
                                        value={hari}
                                        onChange={(event, newInputValue) => {
                                            console.log(newInputValue);
                                            if (newInputValue.length > 0) {
                                                let temp = []
                                                newInputValue.map((el, idx) => {
                                                    temp.push(el.name)
                                                    set_data({
                                                        ...data,
                                                        "hari": temp
                                                    })
                                                })
                                            } else {

                                            }
                                            setHari(newInputValue)
                                            // set_data({
                                            //     ...data,
                                            //     "hari": newInputValue.name
                                            // })
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Hari"
                                            />
                                        }
                                    />
                                </div>
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin="normal"
                                            style={{ marginTop: 37, width: '80%' }}
                                            id="jamSelesai"
                                            required={true}
                                            clearLabel
                                            ampm={false}
                                            label="Jam Selesai"
                                            value={selectedDateEnd}
                                            onChange={handleDateEndChange}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div>
                                    <TextField
                                        style={{ marginTop: 25, width: '80%' }}
                                        id="slotWaktu"
                                        name="Slot Waktu"
                                        label="Slot Waktu"
                                        required={time_type !== null && time_type.name !== "FIFO" && time_type.name !== "FIFO CHECKIN" ? true : false}
                                        error={errorSlotWaktu}
                                        helperText={errorSlotWaktuMessage}
                                        value={time}
                                        placeholder={"10"}
                                        onChange={(e) => {
                                            console.log(time_type);
                                            if (time_type && time_type.name === 'TIMESLOT') {
                                                set_service_duration(e.target.value)
                                            }
                                            set_time(+e.target.value)
                                            setErrorSlotWaktu(false)
                                            setErrorSlotWaktuMessage(null)
                                            set_data({
                                                ...data,
                                                "time": +e.target.value
                                            })
                                        }}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <Autocomplete
                                        // multiple
                                        options={listAntrian}
                                        style={{ marginTop: 37, width: '80%' }}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        name='Layanan Pasien'
                                        id="layananPasien"
                                        value={service_type}
                                        onChange={(event, newInputValue) => {
                                            set_service_type(newInputValue)
                                            setErrorLayanan(false)
                                            setErrorLayananMessage(null)
                                            set_data({
                                                ...data,
                                                "service_type": newInputValue.name
                                            })
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Layanan Pasien"
                                                required={true}
                                                error={errorLayanan}
                                                helperText={errorLayananMessage}
                                            />
                                        }
                                    />
                                </div>
                                <div className="">
                                    <Autocomplete
                                        // multiple
                                        style={{ marginTop: 35, width: '80%' }}
                                        options={list_room}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        name='Lokasi Praktek'
                                        id="lokasiPraktek"
                                        value={room}
                                        onChange={(event, newInputValue) => {
                                            set_room(newInputValue)
                                            set_data({
                                                ...data,
                                                "room": newInputValue.name
                                            })
                                            setFlagging(true)
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Lokasi Praktek"
                                                required={true}
                                            />
                                        }
                                    />
                                </div>
                                <TextField
                                    style={{ width: '80%', marginTop: 30 }}
                                    label="Catatan Internal"
                                    value={internalNotes}
                                    placeholder={"Input Catatan Internal"}
                                    onChange={(e) => {
                                        setInternalNotes(e.target.value)
                                    }}
                                    inputProps={{
                                        style: {

                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                    }
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div onClick={() => handleBatal()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 70, marginRight: 10, cursor: 'pointer', marginTop: 48, }}>
                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                    </div>
                    <div onClick={() => handleSubmit()} style={{ backgroundColor: 'white', borderRadius: 70, textAlign: 'center', width: 205, height: 39, color: '#278863', border: "2px solid #278863", marginTop: 47, cursor: 'pointer' }}>
                        <Typography style={{ marginTop: 4 }}>Simpan Jadwal</Typography>
                    </div>
                </div>
            </div>
            {
                visibleError ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                            <div style={{ margin: 'auto' }}>
                                <div style={{ width: 90, height: 90, borderRadius: 70, backgroundColor: '#34b68b', border: '3px solid #b3fde4', placeContent: 'center' }}>
                                    {/* <img src={circle} style={{width: 100, height: 100}}/> */}
                                    <img src={ic_error} style={{ width: 60, height: 60, marginTop: 10 }} />
                                </div>
                                <Typography style={{ fontStyle: 'bold', letterSpacing: 1.5, fontFamily: 'poppins', fontSize: 18 }}>Error</Typography>
                            </div>
                            <div>
                                <Typography>{errorMessage}</Typography>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                                <div onClick={() => setVisibleError(false)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }

            {visibleNotes && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div style={{ padding: 20 }}>
                            <textarea
                                value={notesDokter}
                                disabled
                                style={{ width: '100%', marginTop: 10, minHeight: 400 }}
                            />
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleNotes(false)}
                                    style={{ height: 28, width: 100, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <Typography style={{ color: 'white', fontSize: 13 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}